export default {
  product_id: null,
  vendor_project_id: null,
  type: null,
  stock: null,
  stock_date: null,
  attachments: null
}